import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import Cookies from "js-cookie";
import { CookiesKey } from "@/types/cookies";

const MEMORIAL_DISCOUNT_SEARCH_PARAM = "memorial_discount";

const useMemorialDiscountCapture = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const memorialDiscount = searchParams.get(MEMORIAL_DISCOUNT_SEARCH_PARAM);
    if (memorialDiscount) {
      Cookies.set(CookiesKey.MEMORIAL_DISCOUNT, memorialDiscount);

      searchParams.delete(MEMORIAL_DISCOUNT_SEARCH_PARAM);
      setSearchParams(searchParams);
    }
  }, [searchParams]);
};

export { useMemorialDiscountCapture, MEMORIAL_DISCOUNT_SEARCH_PARAM };
